import React, { useCallback, useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, Container } from "@mui/material";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";

import { getBulkAppointments } from "../../services/BulkAppointmentSevice";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ValidAppontmentTable from "./ValidAppointmentTable";

import BulkAppointmentBookingBreadCrumbs from "../../breadcrumbs/BulkAppointmentBookingBreadCrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import InvalidAppontmentTable from "./InvalidAppointmentTable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3, px: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BulkAppointmentListDetails = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [appointmentListDetails, setAppointmentListDetails] = useState([]);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchBulkAppointments = useCallback(
    async (bulkRequestId) => {
      try {
        setLoading(true);
        const bulkAppointmentListResponse = await getBulkAppointments(baseUrl, {
          bulkRequestId: bulkRequestId,
        });
        if (bulkAppointmentListResponse?.messageCode === 6) {
          setAppointmentListDetails(
            bulkAppointmentListResponse?.appointmentList
          );
        } else {
          setAppointmentListDetails([]);
          showNotification(
            "Error",
            bulkAppointmentListResponse?.message ??
              "Failed To Fetch Bulk Appointment Details"
          );
        }
      } catch (err) {
        showNotification(
          "Error",
          err?.message ?? "Failed To Fetch Bulk Appointment Details"
        );
      } finally {
        setLoading(false);
      }
    },
    [baseUrl, setLoading, showNotification]
  );

  const initialLoad = async (bulkRequestId) => {
    await fetchBulkAppointments(bulkRequestId);
  };

  useEffect(() => {
    if (location && location.state) {
      const state = location.state;
      if (state.bulkRequestId) {
        initialLoad(state?.bulkRequestId);
      }

      window.history.replaceState({}, document.title);
    } else {
      navigate("/bulk-appointment", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
        <Grid container spacing={1} sx={{ pl: 3, pr: 3 }}>
          <Grid item xs={12} md={12}>
            <Box display={"flex"}>
              <BulkAppointmentBookingBreadCrumbs />
            </Box>
          </Grid>
        </Grid>
        <Grid container sx={{ py: 1, pl: 3, pr: 3, pt: 3, pb: 2 }}>
          <Grid item xs={12}>
            <Paper elevation={3} variant="elevation" sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  scrollButtons="auto"
                  aria-label="Bulk Appointment Tabs"
                >
                  <Tab
                    iconPosition="start"
                    label={
                      <Typography
                        variant="button"
                        color="#4d6fa5"
                        sx={{ pt: 0.5 }}
                      >
                        Success Appointments{" "}
                      </Typography>
                    }
                    {...a11yProps(0)}
                  />
                  <Tab
                    iconPosition="start"
                    label={
                      <Typography
                        variant="button"
                        color="#4d6fa5"
                        sx={{ pt: 0.5 }}
                      >
                        Failed Appointments
                      </Typography>
                    }
                    {...a11yProps(1)}
                  />
                </Tabs>
              </Box>

              <TabPanel value={value} index={0} sx={{ p: 0 }}>
                <ValidAppontmentTable
                  appointmentDetailsList={appointmentListDetails?.validRecords}
                />
              </TabPanel>
              <TabPanel value={value} index={1} sx={{ p: 0 }}>
                <InvalidAppontmentTable
                  appointmentDetailsList={
                    appointmentListDetails?.invalidRecords
                  }
                />{" "}
              </TabPanel>
            </Paper>
          </Grid>
        </Grid>
      </Container>{" "}
    </>
  );
};
export default BulkAppointmentListDetails;
